import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import API_BASE_URL from "../api/api";
// const API_URL =
//   process.env.NODE_ENV === "development"
//     ? "http://127.0.0.1:8000/api/top-documents"
//     : "https://api.kunainital.ac.in/api/top-documents";
const API_URL = `${API_BASE_URL}/top-documents`;

export default function NoticeTicker() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log("notices",API_URL);

  useEffect(() => {
    const fetchTopDocuments = async () => {
      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error("Failed to fetch top documents");
        }

        const result = await response.json();
        

        if (result.status && Array.isArray(result.data)) {
          setNotices(result.data);
        } else {
          setNotices([]);
        }
      } catch (error) {
        console.error("Top documents API error:", error);
        setNotices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTopDocuments();
  }, []);

  if (loading) {
    return null;
  }

  if (!notices.length) {
    return null;
  }

  // Duplicate notices for continuous ticker animation
  const items = [...notices, ...notices];

  // const getNoticeUrl = (notice) => {
  //   if (notice.external_link) {
  //     return notice.external_link;
  //   }

  //   if (notice.pdf_path) {
  //     return notice.pdf_path;
  //   }

  //   return null;
  // };

 
const getNoticeUrl = (notice) => {
  if (notice.external_link) {
    return notice.external_link;
  }

  if (notice.pdf_path) {
    // AWS S3 ya kisi bhi full URL ko directly use karein
    if (/^https?:\/\//i.test(notice.pdf_path)) {
      return notice.pdf_path;
    }

    // Sirf relative path ke liye local/backend URL banayein
    const baseUrl = API_BASE_URL.replace(/\/api\/?$/, "");

    return `${baseUrl}/storage/${notice.pdf_path.replace(/^\/+/, "")}`;
  }

  return null;
};
  return (
    // <div className="bg-gradient-to-r from-[var(--terracotta-deep)] via-[var(--terracotta)] to-[var(--saffron)] text-white">
       <div
    style={{
      background:
        "linear-gradient(to right, #8b2f1e, #b8452c, #e8871e)",
      color: "#ffffff",
      width: "100%",
      display: "block",
      position: "relative",
      zIndex: 10,
    }}
  >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-3 overflow-hidden">

        {/* Latest */}
        <div className="shrink-0 inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-3.5 py-1.5 text-[12.5px] font-semibold tracking-wider uppercase border border-white/25">
         <Megaphone size={14} />
          Latest
        </div>

        {/* Ticker */}
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {items.map((notice, i) => {
           
              const url = getNoticeUrl(notice);

              return (
                <span
                  key={`${notice.id}-${i}`}
                  className="inline-flex items-center gap-3 text-[14px]"
                >
                  <span className="text-[var(--saffron-light)] font-bold">
                    ✦
                  </span>

                  {url ? (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-medium text-white hover:text-white hover:underline"
                    >
                      {notice.heading}
                    </a>
                  ) : (
                    <span className="font-medium">
                      {notice.heading}
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}